import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    dashboard: "Dashboard", doctors: "Doctors", patients: "Patients",
    appointments: "Appointments", staff: "Staff", departments: "Departments",
    vendors: "Vendors", inventory: "Inventory", lab: "Lab & Radiology", lab_reports: "Lab Reports",
    billing: "Billing", settings: "Settings", logout: "Logout",
    calendar: "Calendar", prescriptions: "Prescriptions", my_portal: "My Portal",
    analytics: "Analytics", insurance: "Insurance", schedule: "Schedule", my_schedule: "My Schedule",
    book_appointment: "Book Appointment", notifications: "Notifications",
    add: "Add", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
    search: "Search", filter: "Filter", close: "Close", confirm: "Confirm",
    active: "Active", inactive: "Inactive", pending: "Pending",
    completed: "Completed", cancelled: "Cancelled", waiting: "Waiting",
    in_consultation: "In Consultation",
    name: "Name", email: "Email", phone: "Phone", address: "Address",
    actions: "Actions", loading: "Loading...", no_data: "No records found",
    login: "Login", register: "Register",
    specialization: "Specialization", consultation_fee: "Consultation Fee",
    room_number: "Room Number", patient_id: "Patient ID", age: "Age",
    gender: "Gender", blood_group: "Blood Group", token: "Token",
    visit_date: "Visit Date", complaint: "Complaint", emergency: "Emergency",
    test_name: "Test Name", test_type: "Test Type", result: "Result",
    amount: "Amount", discount: "Discount", total: "Total",
    payment_mode: "Payment Mode", total_patients: "Total Patients",
    total_doctors: "Total Doctors", today_appointments: "Today's Appointments",
    revenue_today: "Revenue Today", pending_tests: "Pending Lab Tests",
    welcome: "Welcome", role: "Role", shift: "Shift",
    available: "Available", unavailable: "Unavailable",
    in_stock: "In Stock", low_stock: "Low Stock", out_of_stock: "Out of Stock",
    category: "Category", quantity: "Quantity", expiry_date: "Expiry Date",
    company: "Company", contact: "Contact",
  },
  ar: {
    dashboard: "لوحة القيادة", doctors: "الأطباء", patients: "المرضى",
    appointments: "المواعيد", staff: "الموظفون", departments: "الأقسام",
    vendors: "الموردون", inventory: "المخزون", lab: "المختبر والأشعة", lab_reports: "تقارير المختبر",
    billing: "الفواتير", settings: "الإعدادات", logout: "تسجيل الخروج",
    calendar: "التقويم", prescriptions: "الوصفات", my_portal: "بوابتي",
    analytics: "التحليلات", insurance: "التأمين", schedule: "الجدول", my_schedule: "جدولي",
    book_appointment: "حجز موعد", notifications: "الإشعارات",
    add: "إضافة", edit: "تعديل", delete: "حذف", save: "حفظ", cancel: "إلغاء",
    search: "بحث", filter: "تصفية", close: "إغلاق", confirm: "تأكيد",
    active: "نشط", inactive: "غير نشط", pending: "معلق",
    completed: "مكتمل", cancelled: "ملغى", waiting: "في الانتظار",
    in_consultation: "في الاستشارة",
    name: "الاسم", email: "البريد الإلكتروني", phone: "الهاتف", address: "العنوان",
    actions: "الإجراءات", loading: "جاري التحميل...", no_data: "لا توجد سجلات",
    login: "تسجيل الدخول", register: "تسجيل",
    specialization: "التخصص", consultation_fee: "رسوم الاستشارة",
    room_number: "رقم الغرفة", patient_id: "رقم المريض", age: "العمر",
    gender: "الجنس", blood_group: "فصيلة الدم", token: "الرمز",
    visit_date: "تاريخ الزيارة", complaint: "الشكوى", emergency: "طارئ",
    test_name: "اسم الاختبار", test_type: "نوع الاختبار", result: "النتيجة",
    amount: "المبلغ", discount: "الخصم", total: "الإجمالي",
    payment_mode: "طريقة الدفع", total_patients: "إجمالي المرضى",
    total_doctors: "إجمالي الأطباء", today_appointments: "مواعيد اليوم",
    revenue_today: "إيرادات اليوم", pending_tests: "الاختبارات المعلقة",
    welcome: "مرحباً", role: "الدور", shift: "الوردية",
    available: "متاح", unavailable: "غير متاح",
    in_stock: "متوفر", low_stock: "مخزون منخفض", out_of_stock: "نفد المخزون",
    category: "الفئة", quantity: "الكمية", expiry_date: "تاريخ الانتهاء",
    company: "الشركة", contact: "التواصل",
  },
  hi: {
    dashboard: "डैशबोर्ड", doctors: "डॉक्टर", patients: "मरीज़",
    appointments: "अपॉइंटमेंट", staff: "स्टाफ", departments: "विभाग",
    vendors: "विक्रेता", inventory: "इन्वेंटरी", lab: "लैब और रेडियोलॉजी", lab_reports: "लैब रिपोर्ट",
    billing: "बिलिंग", settings: "सेटिंग्स", logout: "लॉगआउट",
    calendar: "कैलेंडर", prescriptions: "नुस्खे", my_portal: "मेरा पोर्टल",
    analytics: "विश्लेषण", insurance: "बीमा", schedule: "समय-सारणी", my_schedule: "मेरी समय-सारणी",
    book_appointment: "अपॉइंटमेंट बुक करें", notifications: "सूचनाएँ",
    add: "जोड़ें", edit: "संपादित करें", delete: "हटाएं", save: "सहेजें",
    cancel: "रद्द करें", search: "खोजें", filter: "फिल्टर", close: "बंद करें",
    confirm: "पुष्टि करें", active: "सक्रिय", inactive: "निष्क्रिय",
    pending: "लंबित", completed: "पूर्ण", cancelled: "रद्द", waiting: "प्रतीक्षारत",
    in_consultation: "परामर्श में",
    name: "नाम", email: "ईमेल", phone: "फोन", address: "पता",
    actions: "कार्रवाई", loading: "लोड हो रहा है...", no_data: "कोई रिकॉर्ड नहीं",
    login: "लॉगिन", register: "रजिस्टर",
    specialization: "विशेषज्ञता", consultation_fee: "परामर्श शुल्क",
    room_number: "कक्ष संख्या", patient_id: "मरीज़ ID", age: "आयु",
    gender: "लिंग", blood_group: "रक्त समूह", token: "टोकन",
    visit_date: "दौरा तिथि", complaint: "शिकायत", emergency: "आपातकाल",
    test_name: "परीक्षण नाम", test_type: "परीक्षण प्रकार", result: "परिणाम",
    amount: "राशि", discount: "छूट", total: "कुल",
    payment_mode: "भुगतान विधि", total_patients: "कुल मरीज़",
    total_doctors: "कुल डॉक्टर", today_appointments: "आज के अपॉइंटमेंट",
    revenue_today: "आज की आय", pending_tests: "लंबित परीक्षण",
    welcome: "स्वागत", role: "भूमिका", shift: "पाली",
    available: "उपलब्ध", unavailable: "अनुपलब्ध",
    in_stock: "स्टॉक में", low_stock: "कम स्टॉक", out_of_stock: "स्टॉक समाप्त",
    category: "श्रेणी", quantity: "मात्रा", expiry_date: "समाप्ति तिथि",
    company: "कंपनी", contact: "संपर्क",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(localStorage.getItem("lang") || "en");
  const isRTL = language === "ar";

  useEffect(() => {
    document.documentElement.dir = isRTL ? "rtl" : "ltr";
    document.documentElement.lang = language;
    localStorage.setItem("lang", language);
  }, [language, isRTL]);

  const t = (key) => translations[language]?.[key] || translations.en[key] || key;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
